var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8050_3693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.667 23.3333V9.99996C31.667 8.16663 30.167 6.66663 28.3337 6.66663H5.00033C3.16699 6.66663 1.66699 8.16663 1.66699 9.99996V23.3333C1.66699 25.1666 3.16699 26.6666 5.00033 26.6666H28.3337C30.167 26.6666 31.667 25.1666 31.667 23.3333ZM16.667 21.6666C13.9003 21.6666 11.667 19.4333 11.667 16.6666C11.667 13.9 13.9003 11.6666 16.667 11.6666C19.4337 11.6666 21.667 13.9 21.667 16.6666C21.667 19.4333 19.4337 21.6666 16.667 21.6666ZM38.3337 11.6666V30C38.3337 31.8333 36.8337 33.3333 35.0003 33.3333H6.66699V30H35.0003V11.6666H38.3337Z",
    fill: "#0000FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8050_3693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.8d65fa974e6f02a2181b97cf3b5fe316.svg";
export { ForwardRef as ReactComponent };